import { useAds } from 'hooks/use-ads';
import React, { useEffect, useRef, useState } from 'react';
import { AdSlotMarker, AdSlotMarkerProps } from '../ad-slot-marker/ad-slot-marker';
import './ad-slot-corner.scss';

const HIDE_CLASS = 'creation-corner--hidden';

const getKey = (slot: any): string => (slot?.ads[0]?.adid ?? '').replace(/[^a-zA-Z0-9]/g, '.') || null;

const AdSlotCorner: React.FC<AdSlotMarkerProps> = ({ name, lazy, resizable }) => {
    const ads = useAds();
    const disabled = !ads || !ads.enabled;

    const id = `ad-${name}`;
    const ref = useRef<HTMLDivElement>(null);
    const adId = useRef<string | null>(null);
    const [slot, setSlot] = useState<any>(null);

    const hide = (): void => ref.current?.parentElement?.classList.add(HIDE_CLASS);

    const show = (): void => {
        if (adId?.current && !sessionStorage[adId.current]) {
            ref.current?.parentElement?.classList.remove(HIDE_CLASS);
        }
    };

    const clean = (): void => {
        setTimeout(() => slot?.destroy(), 500);
    };

    const close = (): void => {
        if (adId.current) {
            sessionStorage[adId.current] = '1';
        }

        hide();
        clean();
    };

    useEffect(() => {
        if (disabled) {
            return;
        }

        if (slot) {
            slot.on('render', show);
            slot.on('display', (item: any) => {
                adId.current = getKey(item);

                if (adId.current && sessionStorage[adId.current]) {
                    slot.destroy();
                }
            });
        } else {
            window?.onetAds?.cmd.push((dlApi): void => setSlot((): any => dlApi.defineSlot(name, id, {}).setCollapseEmpty(true)));
        }
    }, [slot, disabled]);

    if (disabled) {
        return null;
    }

    return (
        <div className="creation-corner creation-corner--hidden">
            <div ref={ref} className="creation-corner__close" onClick={close}
                role="button" tabIndex={0}
            >
                X
            </div>
            <AdSlotMarker id={id} auto={false} name={name}
                lazy={lazy} resizable={resizable}
            />
        </div>
    );
};

export default AdSlotCorner;
